import request from './base';
import {camelToSnake, excludeObjNullValue} from '../utils/common';

export const fetchQuizzes = ({q, page, perPage, sortOpts, extraParams}) => (
    request.fetchList({url: '/quizzes', q, page, perPage, sortOpts, extraParams})
);

export const fetchQuiz = (id) => request.fetchDetail(`/quizzes/${id}`);

export const createQuiz = (payload) => request.postJSON(
    '/quizzes',
    excludeObjNullValue({
        name: payload.name,
        questions: payload.questions || [],
        options: camelToSnake(payload.options),
        start_message: payload.start_message,
        end_message: payload.end_message,
    })
);

export const updateQuiz = (id, payload) => request.postJSON(
    `/quizzes/${id}`,
    excludeObjNullValue({
        name: payload.name,
        questions: payload.questions || [],
        options: camelToSnake(payload.options),
        start_message: payload.start_message,
        end_message: payload.end_message,
    })
);

export const deleteQuiz = (quizId) => request.deleteReq(`/quizzes/${quizId}`);

export const startQuiz = (quizId, queryArgs) => request.getJSON(
    `/quizzes/${quizId}/start`,
    queryArgs
);

export const progressQuiz = (quizId, userQuizId, student_answer) => request.postJSON(
    `/quizzes/${quizId}/progress`,
    {   
        user_quiz_id: userQuizId,
        student_answer:  student_answer
    }
);


export const previewQuiz = (quizId) => request.getJSON(
    `/quizzes/${quizId}/preview`
);

export const submitAnswer = (quizId, userQuizId, answers) => request.postJSON(
    `/quizzes/${quizId}/answer`,
    {
        user_quiz_id: userQuizId,
        answers: answers,
    }
);

export const fetchQuizResults = (quizId, {q, page, perPage, sortOpts, extraParams}) => (
    request.fetchList({url: `/quizzes/${quizId}/results`, q, page, perPage, sortOpts, extraParams})
);

export const fetchUserQuiz = (userQuizId) => request.fetchDetail(`/user_quizzes/${userQuizId}`);

export const importQuiz = (zipfile) => request.postFile(
    '/quizzes/import',
    zipfile
);

export const fetchAnalytics = (quizId, {q, page, perPage, sortOpts, extraParams}) => (
    request.fetchList({url: `/quiz/${quizId}/analytics`, q, page, perPage, sortOpts, extraParams})
);

export const fetchTopics = (topic) => (
    request.fetchList({url: `/topics?topic=${topic}`})
);

export const instanceQuiz = (quizId, userQuizId) => request.getJSON(
    `/quizzes/${quizId}/${userQuizId}/instance`
);

export const postInstance = (quizId, currentIndex, userQuizId) => request.postJSON(
    `/quizzes/${quizId}/post_instance`,
    {
        quiz_id: quizId,
        current_index: currentIndex,
        user_quiz_id: userQuizId,
    }
);

export const topicScore = (quizId, userQuizId, topic) => request.postJSON(
    `/quizzes/${quizId}/score_topic`,
    {
        user_quiz_id: userQuizId,
        topic: topic,
    }
)
